<template>
  <div class="w-full col-span-full">
    <info-bulle
      :libelle="labelLibelle"
      :name="name"
      :is-libelle-input="true"
    >
      <template #libelleBefore>
        <p
          v-html="textLibelle"
          :for="name"
          class="text-sm text-gray-600 truncate mb-2"
          :style="
            inherits != undefined && inherits != null && inherits
              ? 'color: inherit; font-size: inherit; font-weight: inherit;'
              : ''
          "
          @mouseover="tooltipLibelle = true"
          @mouseleave="tooltipLibelle = false"
        />
        <span
          v-if="required"
          class="text-pink-600 ml-1"
        >*</span>
      </template>
      <template #tooltipLibelleBefore>
        <!-- Display libelle when hover -->
        <transition
          enter-active-class="duration-300 delay-1000"
          enter-class="opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-300"
          leave-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <div
            v-if="tooltipLibelle && libelle != null && libelle != ''"
            class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-8 z-30 p-3 text-sm w-max-content w-max max-w-128"
          >
            {{ libelle }}
          </div>
        </transition>
      </template>
    </info-bulle>

    <div
      class="inline-block relative w-full"
      @mouseover="tooltipValue = true"
      @mouseleave="tooltipValue = false"
    >
      <input
        v-if="count <= 3"
        readonly
        type="text"
        :name="name"
        class="multi-select-input bg-white border border-indigo-600 rounded-md placeholder-gray-600 pl-3 pr-7 py-2 xxl:pl-4 xxl:pr-8 xxl:py-3 2xl:pl-5 2xl:pr-9 2xl:py-4 block w-full focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 appearance-none transition duration-150 ease-in-out text-sm sm:leading-5 truncate"
        :value="formatedValues.join(', ')"
        autocomplete="off"
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
        :class="{
          'bg-gray-200 cursor-not-allowed': disabled || disabled_pass,
          'cursor-pointer': !(disabled || disabled_pass),
        }"
      />
      <input
        v-else
        readonly
        type="text"
        :name="name"
        autocomplete="off"
        class="multi-select-input bg-white border border-indigo-600 rounded-md placeholder-gray-600 pl-3 pr-7 py-2 xxl:pl-4 xxl:pr-8 xxl:py-3 2xl:pl-5 2xl:pr-9 2xl:py-4 block w-full focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50 appearance-none transition duration-150 ease-in-out text-sm leading-5"
        :value="count + ' sélectionnés'"
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
        :class="{
          'bg-gray-200 cursor-not-allowed': disabled || disabled_pass,
          'cursor-pointer': !(disabled || disabled_pass),
        }"
      />
      <div
        v-if="!(disabled || disabled_pass)"
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center text-pink-600 px-4"
      >
        <icon name="chevron-down" />
      </div>
      <!-- Display value when hover -->
      <transition
        enter-active-class="duration-300 delay-300"
        enter-class="opacity-0"
        enter-to-class="opacity-100"
        leave-active-class="duration-300"
        leave-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-html="formatedValues.join(', ')"
          v-if="tooltipValue && mutableValue != null && mutableValue != ''"
          class="absolute rounded-lg shadow-lg bg-indigo-600 text-white bottom-12 z-30 p-3 text-sm w-max-content w-max max-w-128"
        />
      </transition>
      <!-- BEGIN Select field appears when click on input -->
      <div
        class="multi-select-menu z-20 absolute overflow-scroll max-h-60 mt-4 rounded-xl bg-white shadow-lg shadow-gray-600 text-sm ml-auto w-max-content w-max max-w-full lg:max-w-128 p-5"
        :class="left ? '' : 'right-0'"
        :hidden="hide"
        :name="this.name"
        v-click-outside="forceHide"
      >
        <div>
          <div
            v-if="hasItemAll"
            class="multi-select-element cursor-default pb-3 last:pb-1 text-gray-900"
          >
            <div
              @click.stop="hasAllSelected ? deselectAll() : selectAll()"
              class="multi-select-element pb-1 text-gray-600 hover:text-gray-900 relative flex items-center cursor-pointer"
            >
              <div class="cursor-pointer flex items-center justify-center">
                <input
                  type="checkbox"
                  :name="'all' + name"
                  :value="hasAllSelected"
                  class="appearance-none h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-2 rounded"
                  :class="
                    disabled || disabled_pass
                      ? 'bg-gray-200 border-gray-600 cursor-not-allowed'
                      : hasAllSelected
                        ? 'border-indigo-600 bg-indigo-600'
                        : 'border-indigo-600 bg-white'
                  "
                  :disabled="disabled || disabled_pass"
                />
                <icon
                  v-if="hasAllSelected"
                  name="checkmark"
                  width="12px"
                  height="8px"
                  class="pointer-events-none absolute text-white"
                />
              </div>
              <label
                :for="'all' + name"
                class="ml-2 group-hover:text-gray-900 cursor-pointer w-full"
              >
                {{ libelleItemAll }}
              </label>
            </div>
          </div>

          <div v-if="groups.length > 0">
            <div
              class="multi-select-element cursor-default pb-3 last:pb-1 text-gray-900"
              v-for="(group, igroup) in groups"
              :key="igroup"
            >
              <div
                @click.stop="toggleGroup(group)"
                class="multi-select-element pb-2 text-gray-600 hover:text-gray-900 relative flex items-center cursor-pointer"
              >
                <div class="cursor-pointer flex items-center justify-center">
                  <input
                    type="checkbox"
                    :name="'all' + name"
                    :value="groupIsSelected(group)"
                    class="appearance-none h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-2 rounded"
                    :class="
                      disabled || disabled_pass
                        ? 'bg-gray-200 border-gray-600 cursor-not-allowed'
                        : groupIsSelected(group)
                          ? 'border-indigo-600 bg-indigo-600'
                          : 'border-indigo-600 bg-white'
                    "
                    :disabled="disabled || disabled_pass"
                  />
                  <icon
                    v-if="groupIsSelected(group)"
                    name="checkmark"
                    width="12px"
                    height="8px"
                    class="pointer-events-none absolute text-white"
                  />
                </div>
                <label
                  :for="'group' + name+group"
                  class="ml-2 group-hover:text-gray-900 cursor-pointer w-full"
                >
                  {{ group }}
                </label>
              </div>
              <div
                class="multi-select-element ml-2 pb-1 text-gray-600 hover:text-gray-900 relative flex items-center cursor-pointer"
                v-for="(data, index) in listDatas.filter(
                  (d) => d.group === group
                )"
                :key="index"
                @click="addEl"
              >
                <div class="cursor-pointer flex items-center justify-center">
                  <input
                    type="checkbox"
                    :value="data.value"
                    :name="data.value"
                    class="appearance-none h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-2 rounded"
                    :class="
                      disabled || disabled_pass
                        ? 'bg-gray-200 border-gray-600 cursor-not-allowed'
                        : formatedValues.includes(data.value)
                          ? 'border-indigo-600 bg-indigo-600'
                          : 'border-indigo-600 bg-white'
                    "
                    :disabled="disabled || disabled_pass"
                  />

                  <icon
                    v-if="formatedValues.includes(data.value)"
                    name="checkmark"
                    width="12px"
                    height="8px"
                    class="pointer-events-none absolute text-white"
                  />
                </div>
                <label
                  :for="data.value"
                  class="ml-2 group-hover:text-gray-900 cursor-pointer w-full"
                >
                  {{ data.value }}
                </label>
              </div>
            </div>
          </div>

          <div v-if="groups.length === 0">
            <div
              class="multi-select-element pb-1 text-gray-600 hover:text-gray-900 relative flex items-center cursor-pointer"
              v-for="(data, index) in listDatas"
              :key="'data' + index"
              @click="addEl"
            >
              <div class="cursor-pointer flex items-center justify-center">
                <input
                  type="checkbox"
                  :value="data.value"
                  :name="data.value"
                  class="appearance-none h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-2 rounded"
                  :class="
                    disabled || disabled_pass
                      ? 'bg-gray-200 border-gray-600 cursor-not-allowed'
                      : formatedValues.includes(data.value)
                        ? 'border-indigo-600 bg-indigo-600'
                        : 'border-indigo-600 bg-white'
                  "
                  :disabled="disabled || disabled_pass"
                />

                <icon
                  v-if="formatedValues.includes(data.value)"
                  name="checkmark"
                  width="12px"
                  height="8px"
                  class="pointer-events-none absolute text-white"
                />
              </div>
              <label
                :for="data.value"
                class="ml-2 group-hover:text-gray-900 cursor-pointer w-full"
              >
                {{ data.value }}
              </label>
            </div>
          </div>

          <!-- Manage new datas when click on add link -->
          <div v-if="adddata && !valueIsObject && groups.length === 0">
            <div
              class="multi-select-element pb-1 text-gray-600 hover:text-gray-900 relative flex items-center cursor-pointer"
              v-for="(newData, i) in newDatas"
              :key="'new' + i"
            >
              <div class="cursor-pointer flex items-center justify-center">
                <input
                  type="checkbox"
                  :value="newData.value"
                  :name="newData.value"
                  class="appearance-none h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-2 rounded"
                  :class="
                    formatedValues.includes(newData.value)
                      ? 'border-indigo-600 bg-indigo-600'
                      : 'border-indigo-600 bg-white'
                  "
                  :disabled="disabled || disabled_pass"
                  @click="addEl"
                />

                <icon
                  v-if="formatedValues.includes(newData.value)"
                  name="checkmark"
                  width="12px"
                  height="8px"
                  class="pointer-events-none absolute text-white"
                />
              </div>

              <label
                :for="newData.value"
                class="w-full"
              >
                <input
                  :ref="'new' + i"
                  class="appearance-none ml-2 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 transition duration-150 ease-in-out text-gray-600 w-full"
                  type="text"
                  v-model="newData.value"
                  placeholder="Saisir le nom de la catégorie"
                  :disabled="disabled || disabled_pass"
                />
              </label>
            </div>
            <hr class="ml-6 my-2.5" />
            <div
              v-if="adddata"
              class="multi-select-element cursor-pointer ml-6"
            >
              <div
                @click="addData"
                class="text-gray-600 hover:text-gray-900"
              >
                Ajouter nouvelle catégorie
              </div>
            </div>
          </div>
          <!-- END Manage new datas when click on add link -->
        </div>
      </div>
      <!-- END Select field appears when click on input -->
    </div>
    <div
      v-if="error"
      class="text-pink-600 text-sm"
    >
      {{ msgError }}
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Icon from '../../components/Icon';
import InfoBulle from '../../components/InfoBulle';

export default {
  components: {
    Icon,
    InfoBulle,
  },

  props: {
    name: String,
    datas: Array,
    libelle: String,
    value: [String, Object, Number, Array],
    adddata: Boolean,
    necessary: Boolean,
    disabled: Boolean,
    error: Boolean,
    msgError: String,
    labelLibelle: String,
    inherits: Boolean,
    valueIsObject: {
      type: Boolean,
      required: false,
      default: false,
    },
    left: {
      type: Boolean,
      required: false,
      default: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxLengthNewLibelle: Number,
    hasItemAll: {
      type: Boolean,
      required: false,
      default: false,
    },
    libelleItemAll: {
      type: String,
      required: false,
      default: 'Tout',
    },
  },

  data: function () {
    return {
      hide: true,
      mutableValue: this.value,
      newDatas: [],
      first: true,
      disabled_pass: false,
      tooltipLabel: false,
      tooltipValue: false,
      tooltipLibelle: false,
      progressCount: true,
      textLibelle: '&nbsp;',
      groups: [],
    };
  },

  updated() {
    this.makeGroups();
  },

  mounted() {
    this.makeGroups();

    this.mutableValue.forEach((element) => {
      document.getElementsByName(
        this.valueIsObject ? element.value : element
      )[0].checked = true;
    });
    // Manage edit permission for neopass pages
    if (this.$route.path.includes('form/neopass')) {
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if (this.$can(page + '_edit', idpass)) {
        this.disabled_pass = false;
      } else {
        this.disabled_pass = true;
      }
    } else {
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if (this.necessary != undefined && !this.necessary) {
      this.progressCount = false;
    }

    //assign text to textLibelle if prop Libelle is filled
    if (this.libelle != undefined && this.libelle != null) {
      this.textLibelle = this.libelle;
    }
  },

  methods: {
    toggleGroup(group) {
      if (this.groupIsSelected(group)) {
        this.mutableValue = this.mutableValue.filter(item => item.group !== group);
      } else {
        const selectedItemsInGroup = this.mutableValue.filter(item => item.group === group);
        const itemsInGroup = this.datas.filter(item => item.group === group && !selectedItemsInGroup.includes(item));
        itemsInGroup.forEach(item => this.mutableValue.push(item));
      }
    },

    groupIsSelected(group) {
      return this.datas
        .filter(item => item.group === group)
        .every(value => this.mutableValue.includes(value));
    },

    makeGroups() {
      // define optgroup
      this.datas.forEach((element) => {
        if (Object.keys(element).indexOf('group') > -1) {
          //if there is a field name "group" in the element
          if (!this.groups.includes(element.group)) {
            this.groups.push(element.group);
          }
        }
      });
    },

    displayMultiSelect(e) {
      if (e.x < (2 * window.outerWidth) / 3 && this.left) {
        //to move the bloc options on right or left according to the position on the screen
        document
          .querySelectorAll('.multi-select-menu[name="' + this.name + '"]')[0]
          .classList.remove('right-0');
      }
      if (!this.disabled && !this.disabled_pass) {
        this.hide = !this.hide;
      }
    },

    forceHide(e) {
      if (
        e.target.classList.contains('multi-select-input') &&
        e.target.name == this.name &&
        !this.disabled_pass
      ) {
        this.displayMultiSelect(e);
      } else {
        if (!this.hide) {
          this.hide = true;
        }
      }
    },

    selectAll() {
      this.deselectAll(false);

      let allDatas = this.datas.map((d) => d.value).sort();
      let value = this.mutableValue.sort();

      if (JSON.stringify(allDatas) != JSON.stringify(value)) {
        this.datas.forEach((d) => this.mutableValue.push(d.value));
        this.$emit('selectAll', true);
      }
    },

    deselectAll(withEvent = true) {
      this.mutableValue.splice(0);
      if (withEvent) this.$emit('selectAll', false);
    },

    addEl(e) {
      var data = e.target; //If click on checkbox, the data is in e.target

      //First, check the checkbox wherever I click on the line
      //If click on libelle, the checkbox is the first child of the previous sibling which is the div with the checkbox into this.
      if (
        e.target.previousElementSibling != null &&
        e.target.previousElementSibling.children[0] != null
      ) {
        e.target.previousElementSibling.children[0].checked =
          !e.target.previousElementSibling.checked;
        var data = e.target.previousElementSibling.children[0];
      }

      //Then, add the value in Mutable value (passing by this.value)
      /* if (this.hasItemAll && data.value === this.libelleItemAll) {
        this.value.splice(0);

        let allDatas = this.datas.map((d) => d.value).sort();
        let value = this.value.sort();

        if (JSON.stringify(allDatas) != JSON.stringify(value)) {
          this.datas.forEach((d) => this.value.push(d.value));
        }
        return;
      } */
      if (data.value === undefined) {
      } else {
        let elExists = this.valueIsObject
          ? this.value.map((v) => v.value).indexOf(data.value)
          : this.value.indexOf(data.value);
        if (elExists >= 0) {
          this.value.splice(elExists, 1);
        } else {
          this.value.push(
            this.valueIsObject
              ? this.datas[this.datas.map((d) => d.value).indexOf(data.value)]
              : data.value
          );
        }
      }
    },
    addData() {
      let count = this.newDatas.push({ value: '' });
      let lastId = count - 1;

      this.$nextTick(() => {
        this.$refs['new' + lastId][0].focus();
      });
    },
    keepFocus(e) {
      e.target.focus();
    },
  },
  computed: {
    formatedValues() {
      return this.valueIsObject
        ? this.mutableValue.map((v) => v.value)
        : this.mutableValue;
    },

    count() {
      return this.mutableValue.length;
    },

    listMutableValues() {
      return this.formatedValues.join('<br />');
    },
    listDatas() {
      return this.datas.filter(
        (data) =>
          !this.newDatas.map((newData) => newData.value).includes(data.value)
      );
    },
    hasAllSelected() {
      return this.datas
        .map((d) => d.value)
        .every((v) => this.mutableValue.includes(v));
    },
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);
    },
    value() {
      this.mutableValue = this.value;
    },
    newDatas: {
      handler() {
        if (
          this.maxLengthNewLibelle &&
          this.newDatas.filter(
            (data) => data.value.length > this.maxLengthNewLibelle
          ).length > 0
        ) {
          this.$emit(
            'errorMaxLengthNewLibelle',
            'Vous avez atteint la taille maximum de ' +
              this.maxLengthNewLibelle +
              ' caractères pour un libelle.'
          );
          return;
        }
        this.$emit('errorMaxLengthNewLibelle', '');
      },
      deep: true,
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>
